<script>
import { defineComponent } from 'vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwContainer from '@/components/generic/tw-container.vue'

export default defineComponent({
  name: 'TeamDashboardPage',
  components: { TwContainer, TwCard },
  props: {
    teamId: {
      type: Number,
      required: true
    }
  }
})
</script>

<template>
  <tw-container>
    <h3 class="my-6">
      Team Dashboard
    </h3>
    <p class="text-gray-600 mb-4">
      This is the dashboard for your team. Here you can manage your team settings, view team progress, and more.
    </p>
    <tw-card class="bg-white">
      <p>Team ID: {{ teamId }}</p>
      <!-- Add more team-related content here -->
    </tw-card>
  </tw-container>
</template>

<style scoped>

</style>
